import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, onMounted } from 'vue';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Tenant, TenantLite, TenantLoginInfo } from '../store/models';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import tenantModule from '@/store/modules/tenantModule';


export default /*#__PURE__*/_defineComponent({
  __name: 'TenantInfo',
  props: ['tenant', 'tenantLoginInfo', 'tenantInfoLite', 'divStyleClass'],
  setup(__props) {

const props = __props;
const tenantName = ref('');

onMounted(() => {
  const tenant = props.tenant || props.tenantLoginInfo || props.tenantInfoLite;
  tenantName.value = tenant ? tenant.name || '' : '';
});

const appliedDivStyleClass = ref('');

const getAppliedDivStyleClass = () => {
  if (props.divStyleClass) {
    appliedDivStyleClass.value = props.divStyleClass;
  } else {
    appliedDivStyleClass.value = 'text-bold text-subtitle1';
  }
};

getAppliedDivStyleClass();

return (_ctx: any,_cache: any) => {
  return (tenantName.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(appliedDivStyleClass.value)
      }, [
        _createElementVNode("span", null, _toDisplayString(tenantName.value), 1)
      ], 2))
    : _createCommentVNode("", true)
}
}

})